import { combineReducers } from 'redux';
import actionLogReducer from './actionLogReducer';
import consoleTimestampReducer from './consoleTimestampReducer';
import creatingWorkspaceForOrgReducer from './creatingWorkspaceForOrgReducer';
import currentOrganizationReducer from './currentOrganizationReducer';
import currentWorkspaceReducer from './currentWorkspaceReducer';
import drawerReducer from './drawerReducer';
import feedbackDialogReducer from './feedbackDialogReducer';
import organizationDialogReducer from './organizationDialogReducer';
import processesStatisticsFilterReducer from './processesStatisticsFilterReducer';
import selectedActivityRunIdReducer from './selectedActivityRunIdReducer';
import selectedArtifactRunIdReducer from './selectedArtifactRunIdReducer';
import selectedPlanReducer from './selectedPlanReducer';
import selectedProcessIdReducer from './selectedProcessIdReducer';
import selectedRuntimeIdReducer from './selectedRuntimeIdReducer';
import selectedStatisticsProcessIdReducer from './selectedStatisticsProcessIdReducer';
import serviceDeskDialogReducer from './serviceDeskDialogReducer';
import slackDialogReducer from './slackDialogReducer';
import userMessageReducer from './userMessageReducer';
import createApiKeyReducer from './wsKeyDialogState';
import assitantRunsPagingReducer from './assitantRunsPagingReducer';
import onboardingCompletedDialogReducer from './onboardingCompletedDialogReducer';
import creatingOnboardingProcessReducer from './creatingOnboardingProcessReducer';

const uiReducer = combineReducers({
  actions: actionLogReducer,
  drawerOpen: drawerReducer,
  selectedProcessId: selectedProcessIdReducer,
  currentWorkspaceId: currentWorkspaceReducer,
  currentOrganizationId: currentOrganizationReducer,
  selectedArtifactRunId: selectedArtifactRunIdReducer,
  selectedActivityRunId: selectedActivityRunIdReducer,
  consoleTimestampVisible: consoleTimestampReducer,
  slackDialogOpen: slackDialogReducer,
  feedbackDialogOpen: feedbackDialogReducer,
  serviceDeskDialogOpen: serviceDeskDialogReducer,
  creatingWorkspaceForOrg: creatingWorkspaceForOrgReducer,
  organizationsDialogOpen: organizationDialogReducer,
  userMessages: userMessageReducer,
  selectedPlanId: selectedPlanReducer,
  wsKeyDialogState: createApiKeyReducer,
  selectedRuntimeId: selectedRuntimeIdReducer,
  selectedStatisticsProcessId: selectedStatisticsProcessIdReducer,
  processesStatisticsFilter: processesStatisticsFilterReducer,
  assistantRunsPaging: assitantRunsPagingReducer,
  onboardingCompletedDialogOpen: onboardingCompletedDialogReducer,
  creatingOnboardingProcess: creatingOnboardingProcessReducer,
});

export default uiReducer;
